var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlphabeticalFilter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 59.49 42.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .line-1 {\n        stroke-width: 5px;\n      }\n\n      .line-1, .cls-2 {\n        fill: none;\n        stroke: currentColor;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-2 {\n        stroke-width: 6px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 10.47,
    y1: 39.06,
    x2: 10.47,
    y2: 3
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "17.94 32.09 10.47 39.56 3 32.09"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "line-1",
    x1: 41.21,
    y1: 2.38,
    x2: 33.84,
    y2: 17.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "line-1",
    x1: 41.21,
    y1: 2.38,
    x2: 48.58,
    y2: 17.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "line-1",
    x1: 35.76,
    y1: 13.85,
    x2: 46.67,
    y2: 13.85
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "line-1",
    points: "33.84 24.72 48.58 24.72 33.84 40.21 48.58 40.21"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlphabeticalFilter);
export default __webpack_public_path__ + "static/media/alphabetical-filter.98f1fdc2.svg";
export { ForwardRef as ReactComponent };